<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card card-body printableArea">
        <h3>
          <div class="row">
            <div class="col-md-10 col-12">
              <b>Daftar Surat Masuk Siap Kirim</b>
            </div>
            <div class="col-md-2 col-12" v-if="canSeeAll">
              <select class="pull-right form-control" v-model="from" @change="changeDt">
                <option value="me">Diri Sendiri</option>
                <option value="all">Satu Unit</option>
                <option value="pimpinan">Atensi Pimpinan</option>
              </select>
            </div>
          </div>
        </h3>
        <hr>
        <div class="row">
          <div class="col-md-12">
            <Datatables table-name="document_in" :trigger="{
              from: function(){
                return from
              },
              approval:2
            }" @doDetail="doDetail" :columnFiltering="true" @doEdit="doEdit" :action="true" action-data="row_number" :url="'document_in_already'" :dtfields="headers">
              <template slot-scope="props">
              <div class="btn-group btn-sm" role="group" aria-label="Basic example">
                <button type="button" v-if="!forbidRead" data-action="doDetail" class="btn btn-success btn-sm"><i class="mdi mdi-magnify"></i></button>
                <button type="button" v-if="!forbidUpdate && props.ctx.data.canEdit == true" data-action="doEdit" class="btn btn-warning btn-sm"><i class="mdi mdi-grease-pencil"></i></button>
              </div>
              </template>
            </Datatables>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    // let _this = this
    let roles = this.$store.state.profile.user.datarole1;

    return {
      from:roles,
      headers:{
        agenda_number:{
          label:'Nomor Agenda',
          data:'agenda_number',
        },
        nomor_surat:{
          label:'Nomor Surat',
          data:'nomor_surat',
        },
        asal_surat:{
          label:'Asal Surat',
          data:'asal_surat',
        },
        subject:{
          label:'Perihal',
          data:'subject',
        },
        sifat:{
          label:'Sifat Surat',
          data:'sifat',
        },
        tanggal_diterima:{
          label:'Tanggal Diterima',
          data:'tanggal_diterima',
          render:function(data){
            return this.formatDate(data)
          }
        },
        redaksi:{
          label:'Redaksi',
          data:'redaksi',
        },
        status:{
          label:'Status',
          data:'status',
          searchable:false,
          sortable:false,
        },
      }
    };
  },
  computed: {
    forbidUpdate(){
      if(this.$store.state.profile.permissions.document_in){
        return !this.$store.state.profile.permissions.document_in.update;
      }
      return false;
    },
    canSeeAll(){
      if(this.$store.state.profile.permissions.document_in_all){
        return this.$store.state.profile.permissions.document_in_all.read;
      }
      return false;
    },
    forbidRead(){
      if(this.$store.state.profile.permissions.document_in){
        return !this.$store.state.profile.permissions.document_in.read;
      }
      return false;
    },
    forbidAtasan(){
      if(this.$store.state.profile.permissions.document_in){
        return !this.$store.state.profile.permissions.document_in.read;
      }
      return false;
    },
    forbidKonfirmasi(){
      if(this.$store.state.profile.permissions.document_in_confirm){
        return this.$store.state.profile.permissions.document_in_confirm.create;
      }
      return false;
    },
    forbidDel(){
      if(this.$store.state.profile.permissions.document_in){
        return !this.$store.state.profile.permissions.document_in.delete;
      }
      return false;
    },
    forbidDisposisi(){
      if(this.$store.state.profile.permissions.disposition_in){
        return this.$store.state.profile.permissions.disposition_in.create;
      }
      return false;
    }
  },
  mounted() {
    const state = {
      loaded: true,
      isAdd:false,
      isEdit:false,
      isDetail:false,
    };
    this.$store.commit("documentInAlreadySend/STATE", state);
  },
  methods: {
    changeDt(){
      this.$children[0].$refs.table.reload();
    },
    doDetail(val) {
      this.$store.dispatch("documentInAlreadySend/onDetail", val);
      // const idsurat = val.id;
      // let route = this.$router.resolve({path: '/documentInAlreadySend/detail'});
      // let route1 = `${route.href}/${idsurat}`;
      // window.open(route1,'_blank');
    },
    // doBerkas(val) {
    //   const data = {
    //     id: val.id,
    //     flag_atasan: 1,
    //   };
    //   // const data = JSON.stringify(payload);
    //   this.$store.dispatch("documentInAlreadySend/submitTandaiAtasan", data);
    // },
    doAtasan(val) {
      const data = {
        id: val.id,
        flag_atasan: 1,
      };
      // const data = JSON.stringify(payload);
      this.$store.dispatch("documentInAlreadySend/submitTandaiAtasanDepan", data);
    },
    doEdit(val) {
      this.$store.dispatch("documentInAlreadySend/onEdit", val);
    },
    doKonfirmasi(val) {
      this.$store.dispatch("documentInAlreadySend/onKonfirmasi", val);
    },
    // doKonfirmasi(val) {
      //   this.$store.dispatch("documentInAlreadySend/onConfirm", val);
    // },
    doDisposisi(val) {
      this.$store.dispatch("documentInAlreadySend/onDisposisi", val);
    },
    doDelete(val) {
      this.$store.dispatch("documentInAlreadySend/submitDelete", val);
    },
  }
};
</script>
